class FostrArticleProducts extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    if (window.innerWidth < 750) {
      this.initSlider()
    }
  }

  initSlider () {
    new Swiper('.fostr-article-products', {
      slidesPerView: 1.2,
      spaceBetween: 30,
      breakpoints: {
        480: {
          slidesPerView: 1.2,
          spaceBetween: 30
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 30
        }
      }

    })
  }
}

customElements.define('fostr-article-products', FostrArticleProducts);
